import React, { useContext, useState } from 'react';
import { store } from 'components/Store';
import SearchBarWithTeamContent from './SearchBarWithTeamContent';
import transformToPascalCase from 'components/Settings/Utilities/TransformToPascalCase';
import { useParams } from 'react-router';

const EngagementStatisticsRouteDropdown = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { engagementStatisticsResult } = state;
  const [isOpen, setIsOpen] = useState(false);

  const params = useParams();
  const { itemId, type } = params;
  const itemType = transformToPascalCase(type?.split('-').join(' ') ?? '');
  const selectedMaterialTitle = engagementStatisticsResult.find(
    (item) => item.id === parseFloat(itemId) && item.type === itemType
  )?.title;

  return (
    <>
      {engagementStatisticsResult?.length > 0 ? (
        <SearchBarWithTeamContent
          teamsContent={engagementStatisticsResult}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          selectedMaterialTitle={selectedMaterialTitle}
        />
      ) : (
        <div style={{ height: '38px' }}></div>
      )}
    </>
  );
};

export default EngagementStatisticsRouteDropdown;
